module.exports = __webpack_public_path__ + "static/fam-6b8b7bc729bf735afdeba2fe426d0068.jpg";